<template>
<Header hrefTo="#mainView"/>
<Main heading="Sustainability Report">
  <main-view :isContactPage="true">
    <p>Sustainability</p>
  </main-view>
</Main>
<Footer />
</template>

<script>
import Header from "../../components/Header/_Header.vue";
import Main from "../../components/Main/_Main.vue";
import MainView from "../../components/MainView/_MainView.vue"
import Footer from "../../components/Footer/_Footer";

export default {
  name: "Sustainability",
  components: {
    Header,
    Main,
    MainView,
    Footer,
  },
};
</script>

<style lang="scss">
</style>
